import { useTranslation } from "react-i18next";
import FlatList from "src/components/FlatList";
import UserCard from "src/components/UserCard/UserCard";
import useGet from "src/hooks/rest/useGet";

export default function NetworkCompanyView() {
	const { t } = useTranslation("network-view", {
		keyPrefix: "network-company-view",
	});
	const [result, loading, { fetchNext, handleSearch, setResult }] = useGet(
		"/connections",
		{ data: [] },
		true
	);
	const { data, hasMore, meta } = result;
	const total = meta?.total || 0;
	return (
		<FlatList
			{...{ loading, hasMore, handleSearch }}
			title={t("title", {
				count: total,
			})}
			data={data || []}
			onNext={async () => {
				if (hasMore) await fetchNext();
			}}
			gap={16}
			columns={3}
			empty={{
				title: t("empty"),
			}}
			renderItem={(row: any) => (
				<UserCard user={row}>
					<div className="flex gap-2 items-center flex-row justify-between">
						<div className="flex items-center gap-2">
							<UserCard.Avatar />
							<div className="">
								<UserCard.Name />
								<UserCard.Stars />
							</div>
						</div>
						<UserCard.Actions
							onSubmit={(user) => {
								setResult({
									...result,
									meta: {
										...result.meta,
										total: result.meta.total - 1,
									},
									data: result.data.filter(
										(p: any) => p.hid !== user.hid
									),
								});
							}}
						/>
					</div>
					<UserCard.Telephone />
					<div className="flex flex-row justify-between items-center">
						<UserCard.Badges />
						<div className="flex gap-4">
							<UserCard.ButtonCreateTask />
						</div>
					</div>
				</UserCard>
			)}
		/>
	);
}
